import { useMemo } from 'react';

import { createVariationMatcher, normalizeTextForSearch } from '@/util/greekFilter';

type SearchableRow = { name: string; metadata?: { preview?: string } };

const variationsByRow = new WeakMap<SearchableRow, string[]>();

const getRowVariations = (item: SearchableRow) => {
  const cached = variationsByRow.get(item);
  if (cached) {
    return cached;
  }

  const preview = item.metadata?.preview;
  const variations = [
    ...normalizeTextForSearch(item.name),
    ...(preview ? normalizeTextForSearch(preview) : []),
  ];
  variationsByRow.set(item, variations);

  return variations;
};

export function useFilteredBySearch<T extends SearchableRow>(data: T[], search: string): T[] {
  return useMemo(() => {
    if (!search.trim()) {
      return data;
    }

    const matches = createVariationMatcher(search);

    return data.filter((item) => matches(getRowVariations(item)));
  }, [data, search]);
}
